import React from 'react'
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import {useLanguage} from '../store/languageContext'
import {LanguageFactory} from '../factories/Utilities/languageFactory'

interface propTypes{
    color?: string
}

const LanguagePicker = ( props: propTypes ) => {

    const {language, setLanguage} = useLanguage()
    const lang = new LanguageFactory(language)
    const [langPopover, setlangPopover] = React.useState<HTMLElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setlangPopover(event.currentTarget);
    };
    const handleClose = () => {
        setlangPopover(null);
    };

    const open = Boolean(langPopover);
    const id = open ? 'simple-popover' : undefined;

    const changeLanguage = (param: string) => {
        setLanguage(param)
        handleClose()
    }


    return (
        <div className='languagePicker'>
            <Button 
                style = {{'color': props.color}}
                onClick={handleClick} 
                endIcon={<KeyboardArrowDownIcon />} >
                {lang.translate(language, language)}
            </Button>
            <Popover 
                id={id}
                open={open}
                anchorEl={langPopover}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
                <div className = 'PopOver'>
                    <div className='listContainer' data-test="listContainer">
                        <List>
                            {lang.getLanguages().map((item, index) => {
                                return (
                                    <ListItem 
                                        className="listItem"
                                        key={index} 
                                        button selected={ false } 
                                        onClick={() => changeLanguage(item)}>
                                            <ListItemText className="listItemTex" primary={lang.translate(language, item)} />
                                    </ListItem>
                                )
                            })}
                        </List>
                    </div>
                </div>
            </Popover>
        </div>
    )
}

export default LanguagePicker
